<script>
    import { Input } from "sveltestrap";
    
    import Panel from "../../components/Panel2.svelte";
    import Loader from "../../components/Loader.svelte";
	import Button from "../../components/Button.svelte";
	import Modal from "../../components/Modal2.svelte";
    import { createEventDispatcher } from "svelte";
    
	export let table_header_font = ""
	export let table_body_font = ""
	export let token = ""
    export let master = ""
	export let listHome = []
	export let totalrecord = 0
    let dispatch = createEventDispatcher();
	let title_page = "DOMAIN"
    let sData = "";
    let myModal_newentry = "";
    let domain_field = "";
    let tipe_field = "";
    let status_field = "";
    let idrecord = "";
    let searchDomain = "";
    let filterDomain = [];
    let css_loader = "display: none;";
    let msgloader = "";
    $: {
        if (searchDomain) {
            filterDomain = listHome.filter(
                (item) =>
                    item.domain_name
                        .toLowerCase()
                        .includes(searchDomain.toLowerCase())
            );
        } else {
            filterDomain = [...listHome];
        }
    }
    
    const NewData = (e,id,domain,tipe,status) => {
        let flag_modal = true;
        sData = e
        if(sData == "New"){
            clearField()
        }else{
            if(id == null){
                alert("ID Cannot Null")
                flag_modal = false
            }
            idrecord = parseInt(id)
            domain_field = domain;
            tipe_field = tipe;
            status_field = status;
        }
        if(flag_modal){
            myModal_newentry = new bootstrap.Modal(document.getElementById("modalentrycrud"));
            myModal_newentry.show();
        }
    };
    const RefreshHalaman = () => {
        dispatch("handleRefreshData", "call");
    };
    
    
    async function handleSave() {
        let flag = true
        let msg = ""
        if(sData == "New"){
            if(domain_field == ""){
                flag = false
                msg += "The Domain is required\n"
            }
            if(tipe_field == ""){
                flag = false
                msg += "The Tipe is required\n"
            }
            if(status_field == ""){
                flag = false
                msg += "The Status is required\n"
            }
        }else{
            if(idrecord == ""){
                flag = false
                msg += "The ID is required\n"
            }
            if(tipe_field == ""){
                flag = false
                msg += "The Tipe is required\n"
            }
            if(domain_field == ""){
                flag = false
                msg += "The Domain is required\n"
            }
            if(status_field == ""){
                flag = false
                msg += "The Status is required\n"
            }
        }
        
        if(flag){
            css_loader = "display: inline-block;";
            msgloader = "Sending...";
            const res = await fetch("/api/savedomain", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify({
                    sdata: sData,
                    master: master,
                    page:"DOMAIN-SAVE",
                    domain_id: parseInt(idrecord),
                    domain_name: domain_field,
                    domain_tipe: tipe_field,
                    domain_status: status_field,
                }),
            });
            const json = await res.json();
            if (json.status == 200) {
                if(sData=="New"){
                    clearField()
                }
                msgloader = json.message;
                RefreshHalaman()
            } else if(json.status == 403){
                alert(json.message)
            } else {
                msgloader = json.message;
            }
            setTimeout(function () {
                css_loader = "display: none;";
            }, 1000);
        }else{
            alert(msg)
        }
    }
    
    function clearField(){
        idrecord = "";
        domain_field = "";
        tipe_field = "";
        status_field = "";
    }
    function callFunction(event){
        switch(event.detail){
            case "NEW":
                NewData("New","","","");
                break;
            case "REFRESH":
                RefreshHalaman();break;
            case "SAVE":
                handleSubmit();break;
        }
    }
    const handleKeyboard_checkenter = (e) => {
        let keyCode = e.which || e.keyCode;
        if (keyCode === 13) {
                filterTafsirMimpi = [];
                listHome = [];
                const tafsir = {
                    searchTafsirMimpi,
                };
                dispatch("handleTafsirMimpi", tafsir);
        }  
    };
</script>
<div id="loader" style="margin-left:50%;{css_loader}">
    {msgloader}
</div>
<div class="container" style="margin-top: 70px;">
    <div class="row">
        <div class="col-sm-12">
            <Button
                on:click={callFunction}
                button_function="NEW"
                button_title="New"
                button_css="btn-dark"/>
            <Button
                on:click={callFunction}
                button_function="REFRESH"
                button_title="Refresh"
                button_css="btn-primary"/>
            <Panel
                card_search={true}
                card_title="{title_page}"
                card_footer={totalrecord}>
                <slot:template slot="card-search">
                    <div class="col-lg-12" style="padding: 5px;">
                        <input
                            bind:value={searchDomain}
                            on:keypress={handleKeyboard_checkenter}
                            type="text"
                            class="form-control"
                            placeholder="Search Domain"
                            aria-label="Search"/>
                    </div>
                </slot:template>
                <slot:template slot="card-body">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th NOWRAP width="1%" style="text-align: center;vertical-align: top;" >&nbsp;</th>
                                <th NOWRAP width="1%" style="text-align: center;vertical-align: top;font-weight:bold;font-size:{table_header_font};">NO</th>
                                <th NOWRAP width="1%" style="text-align: center;vertical-align: top;font-weight:bold;font-size:{table_header_font};">STATUS</th>
                                <th NOWRAP width="10%" style="text-align: left;vertical-align: top;font-weight:bold;font-size:{table_header_font};">TIPE</th>
                                <th NOWRAP width="*" style="text-align: left;vertical-align: top;font-weight:bold;font-size: {table_header_font};">DOMAIN</th>
                            </tr>
                        </thead>
                        {#if totalrecord > 0}
                        <tbody>
                            {#each filterDomain as rec }
                                <tr>
                                    <td NOWRAP style="text-align: center;vertical-align: top;cursor:pointer;">
                                        <i 
                                            on:click={() => {
                                                NewData("Edit",rec.domain_iddomain,rec.domain_name,rec.domain_tipe ,rec.domain_status);
                                            }} 
                                            class="bi bi-pencil"></i>
                                    </td>
                                    <td NOWRAP style="text-align: center;vertical-align: top;font-size: {table_body_font};">{rec.domain_no}</td>
                                    <td NOWRAP style="text-align: center;vertical-align: top;font-size: {table_body_font};{rec.tafsirmimpi_statuscss}">{rec.domain_status}</td>
                                    <td  style="text-align: left;vertical-align: top;font-size: {table_body_font};">{rec.domain_tipe}</td>
                                    <td  style="text-align: left;vertical-align: top;font-size: {table_body_font};">{rec.domain_name}</td>
                                </tr>
                            {/each}
                        </tbody>
                        {:else}
                        <tbody>
                            <tr>
                                <td colspan="20">
                                    <center>
                                        <Loader />
                                    </center>
                                </td>
                            </tr>
                        </tbody>
                        {/if} 
                    </table>
                </slot:template>
            </Panel>
        </div>
    </div>
</div>

<Modal
	modal_id="modalentrycrud"
	modal_size="modal-dialog-centered"
	modal_title="{title_page+"/"+sData}"
    modal_footer_css="padding:5px;"
	modal_footer={true}>
	<slot:template slot="body">
        <div class="mb-3">
            <label for="exampleForm" class="form-label">Domain</label>
            <Input
                bind:value={domain_field}
                class="required"
                type="text"
                placeholder="Domain"/>
        </div>
        <div class="mb-3">
            <label for="exampleForm" class="form-label">Tipe</label>
            <select class="form-control required" bind:value="{tipe_field}">
                <option value="FRONTEND">FRONTEND</option>
                <option value="AGEN">AGEN</option>
            </select>
        </div>
        <div class="mb-3">
            <label for="exampleForm" class="form-label">Status</label>
            <select class="form-control required" bind:value="{status_field}">
                <option value="RUNNING">RUNNING</option>
                <option value="BANNED">BANNED</option>
            </select>
        </div>
	</slot:template>
	<slot:template slot="footer">
        <Button
            on:click={() => {
                handleSave();
            }} 
            button_function="SAVE"
            button_title="Save"
            button_css="btn-warning"/>
	</slot:template>
</Modal>